/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';

import DatePickerToggle from '../../../components/DatePickerToggle';
import { TimeFromNow } from '../../../localization/LocalizedDate';

interface Props {
  startDate: string;
  startDatePrecision: string;
  hasInitialFocus?: boolean;
  onChangeStartDate(d): void;
  onFocusStartDate(): void;
  onCancelStartDate(): void;
  earliestDateLimit: string;
  latestDateLimit: string;
  warningHint: string;
  earliestDateWarningLimit: string;
}

export const HealthEntryWhenCurrent: React.FC<Props> = (props) => (
  <DatePickerToggle
    label="currentDates.startDate.field.label"
    date={props.startDate}
    precision={props.startDatePrecision}
    name="start_date"
    onChange={props.onChangeStartDate}
    isFuzzy
    hasToday
    allowNull
    initialFocus={props.hasInitialFocus}
    onFocus={props.onFocusStartDate}
    onCancel={props.onCancelStartDate}
    earliestDateLimit={props.earliestDateLimit}
    latestDateLimit={props.latestDateLimit}
    warningHint={props.warningHint}
    earliestDateWarningLimit={props.earliestDateWarningLimit}
    regularHint={(
      <TimeFromNow
        dateData={{
          date: props.startDate,
          precision: props.startDatePrecision,
        }}
      />
    )}
  />
);
